export default __webpack_public_path__ + "static/media/arrowLeft.2de91474.svg";